import React from "react";
import { Link } from "react-router-dom";
import { useAddress, useDisconnect, useMetamask } from '@thirdweb-dev/react';

function Navbar (){
    const address = useAddress();
    const connectWithMetamask = useMetamask();
    const disconnectWallet = useDisconnect();
    return(<nav className="navbar navbar-dark navbar-expand-lg bg-dark">
    <div className="container-fluid">
      <a className="navbar-brand" href="#">L3nd</a>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
          <li className="nav-item">
            <Link to="/" className= "nav-link active" aria-current="page">Home</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/borrow">Borrow</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/lend">Lend</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/profile">Profile</Link>
          </li>
        </ul>
      {address ? (
        <>
          <p className="nav-item">Your Reputation: </p>
          <button className="btn btn-light" onClick={disconnectWallet}>Disconnect Wallet</button>
        </>
      ) : (
        <button className="btn btn-light" onClick={connectWithMetamask}>Connect with Metamask</button>
      )}
      </div>
    </div>
  </nav>
  )
}

export default Navbar;